import React from "react";
import {
  KTMScreen,
  ActionEvent,
  RenderEvent,
  renderScreen,
  RadioButtons,
} from "ktm-ui";
import { KTMApi } from "api/KTMApi";
import {
  Layout,
  Dialog,
  Button,
  Display,
  Card,
  Column,
  Panel,
  Line,
} from "ktm-ui";
import AdvisorLookup from "enroll/lookups/Advisor";
import AccountHolderLookup from "enroll/lookups/Policy_holder";
import toastr from "toastr";
import CustomToolTip from "../../components/CustomToolTip";
import { CustomDropdown } from "components/CustomDropdown";
import { NationalDistributionPartnerBadge } from "components/NationalDistributionPartnerBadge";
import axios from "axios";

interface IdsPolicy {
  PolicyHolderName: string;
  PolicyHolder_Id: string;
  PolicyName: string;
  DistroAccount: string;
  PrimaryAdvisor_Id: string;
  IsNationalDistributionPartner: boolean;
  Mode: string;
  Policy_Id: string;
  PolicyNo: string;
  Representative: string;
  Region1: string;
  Region1Rate: number;
  Region2: string;
  Region2Rate: number;
  Region3: string;
  Region3Rate: number;
}

interface IdsBenefitYear {
  Id: string;
  StartDate: string;
  EndDate: string;
  RunoffMonths: number;
}

const representatives = ["-- Select --", "NONE", "SALESON", "SALESAB", "JG"];
const regionOptions = ["NONE", "REG1", "REG2", "REG3"];

export default KTMScreen(
  { name: "enroll.policy.new" },
  class extends React.Component<{
    new_policy_id: string;
    policyNumbers?: string[];
  }> {
    data: {
      dsPolicy: IdsPolicy;
      dsBenefitYear: IdsBenefitYear;
    };

    state = {
      policyNumber: this.props.new_policy_id,
      selectedRep: "NONE",
      selectedRegion1: "NONE" as string,
      region1Rate: 0,
      selectedRegion2: "NONE" as string,
      region2Rate: 0,
      selectedRegion3: "NONE" as string,
      region3Rate: 0,
    };

    render() {
      return renderScreen(this);
    }

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsPolicy";
      await KTMApi.start(screen, {
        "@new_policy_id": this.props.new_policy_id,
      });
      screen.title = "New Enrollment";
      screen.setLookup("PrimaryAdvisor_Id", {
        template: this.advisor_lookup,
        autoLaunch: true,
      });
      screen.setLookup("PolicyHolder_Id", {
        template: this.account_holder_lookup,
        autoLaunch: true,
      });
      screen.setOptions("Mode", [
        { value: "NEW", label: "New policy holder" },
        { value: "ADD", label: "Add a policy to existing policy holder" },
      ]);
      screen.setOptions("@dsBenefitYear.RunoffMonths", [
        { value: "1", label: "1 month" },
        { value: "2", label: "2 months" },
        { value: "3", label: "3 months" },
      ]);
      screen.setOnValueChanged("Mode", this.mode_onchange);
      screen.setOnValueChanged("PrimaryAdvisor_Id", this.advisor_onchange);
    }

    advisor_lookup({ getValue, eventValue }: RenderEvent) {
      return <AdvisorLookup eventValue={eventValue} />;
    }

    account_holder_lookup({ getValue, eventValue }: RenderEvent) {
      return <AccountHolderLookup eventValue={eventValue} />;
    }

    main({ field, draw, action }: RenderEvent) {
      return (
        <Layout dialogSize="full">
          {draw(this.header)}
          {draw(this.main_tab)}
          {draw(this.footer)}
        </Layout>
      );
    }

    header({ field, draw, action }: RenderEvent) {
      return <Dialog.Header label="New Enrollment" />;
    }

    footer({ field, draw, action }: RenderEvent) {
      const hasAnyRegion =
        this.state.selectedRegion1 !== "NONE" ||
        this.state.selectedRegion2 !== "NONE" ||
        this.state.selectedRegion3 !== "NONE";
      const rateSum =
        (this.state.selectedRegion1 !== "NONE" ? Number(this.state.region1Rate) || 0 : 0) +
        (this.state.selectedRegion2 !== "NONE" ? Number(this.state.region2Rate) || 0 : 0) +
        (this.state.selectedRegion3 !== "NONE" ? Number(this.state.region3Rate) || 0 : 0);
      const regionInvalid = hasAnyRegion && rateSum !== 100;

      var isDisabled =
        this.data.dsPolicy.PrimaryAdvisor_Id === undefined ||
        this.state.policyNumber === undefined ||
        this.data.dsBenefitYear.StartDate === undefined ||
        this.data.dsBenefitYear.EndDate === undefined ||
        this.data.dsBenefitYear.RunoffMonths === undefined ||
        this.data.dsPolicy.PrimaryAdvisor_Id === null ||
        this.state.policyNumber === null ||
        this.state.policyNumber === "" ||
        this.data.dsBenefitYear.StartDate === null ||
        this.data.dsBenefitYear.EndDate === null ||
        this.data.dsBenefitYear.RunoffMonths === null ||
        regionInvalid
          ? true
          : false;

      return (
        <Dialog.Footer>
          <Button
            action={action(this.submit)}
            label="Create enrollment"
            size="large"
            style="primary"
            disable={isDisabled}
          />
        </Dialog.Footer>
      );
    }

    new_account_holder({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Display field={field("PolicyHolderName")} />
          <div className="RT-Line__content RT-Line__content--space-evenly">
            <div className="RT-Line__item">
              <div className="RT-TextBox">
                <label>Policy Number</label>
                <div className="RT-TextBox__container">
                  <input
                    onChange={(e) => {
                      this.setState({
                        policyNumber: e.target.value,
                      });
                    }}
                    className="RT-TextBox__input"
                    type="number"
                    value={this.state.policyNumber}
                  />
                </div>
              </div>
            </div>
            <div className="RT-Line__item">
              <div className="policy-dropdown-field">
                <div className="RT-TextBox">
                  <label className="RT-Label">Representative</label>
                  <CustomDropdown
                    options={representatives}
                    selectedOption={this.state.selectedRep}
                    setSelectedOption={this.setSelectedOption}
                  />
                </div>
              </div>
            </div>
          </div>
          <Card label="Regions">
            {this.renderRegionSection()}
          </Card>
          <div>
            The next available policy number is:{" "}
            <b>{this.props.new_policy_id}</b>
          </div>
        </Card>
      );
    }

    getAvailableRegions = (currentSlot: number) => {
      const selected = [
        this.state.selectedRegion1,
        this.state.selectedRegion2,
        this.state.selectedRegion3,
      ];
      return regionOptions.filter(
        (r) => r === "NONE" || r === selected[currentSlot] || !selected.includes(r)
      );
    };

    setRegion = (slot: number, value: string) => {
      if (slot === 0) {
        if (value === "NONE") {
          this.setState({ selectedRegion1: "NONE", region1Rate: 0, selectedRegion2: "NONE", region2Rate: 0, selectedRegion3: "NONE", region3Rate: 0 });
        } else {
          this.setState({ selectedRegion1: value });
        }
      } else if (slot === 1) {
        if (value === "NONE") {
          this.setState({ selectedRegion2: "NONE", region2Rate: 0, selectedRegion3: "NONE", region3Rate: 0 });
        } else {
          this.setState({ selectedRegion2: value });
        }
      } else {
        if (value === "NONE") {
          this.setState({ selectedRegion3: "NONE", region3Rate: 0 });
        } else {
          this.setState({ selectedRegion3: value });
        }
      }
    };

    setRegionRate = (slot: number, value: string) => {
      const num = value === "" ? 0 : parseFloat(value);
      if (slot === 0) this.setState({ region1Rate: isNaN(num) ? 0 : num });
      else if (slot === 1) this.setState({ region2Rate: isNaN(num) ? 0 : num });
      else this.setState({ region3Rate: isNaN(num) ? 0 : num });
    };

    renderRegionRow(slot: number, label: string, selectedRegion: string, rate: number) {
      return (
        <div style={{ display: "flex", gap: 12, alignItems: "flex-end", marginBottom: 4 }}>
          <div className="policy-dropdown-field" style={{ flex: "0 0 180px" }}>
            <div className="RT-TextBox">
              <label className="RT-Label">{label}</label>
              <CustomDropdown
                options={this.getAvailableRegions(slot)}
                selectedOption={selectedRegion}
                setSelectedOption={(v: string) => this.setRegion(slot, v)}
              />
            </div>
          </div>
          {selectedRegion !== "NONE" && (
            <div className="RT-TextBox" style={{ flex: "0 0 90px" }}>
              <label className="RT-Label">Rate (%)</label>
              <div className="RT-TextBox__container">
                <input
                  className="RT-TextBox__input"
                  type="number"
                  value={rate}
                  onChange={(e) => this.setRegionRate(slot, e.target.value)}
                />
              </div>
            </div>
          )}
        </div>
      );
    }

    renderRegionSection() {
      const { selectedRegion1, region1Rate, selectedRegion2, region2Rate, selectedRegion3, region3Rate } = this.state;
      const hasAnyRegion = selectedRegion1 !== "NONE" || selectedRegion2 !== "NONE" || selectedRegion3 !== "NONE";
      const rateSum =
        (selectedRegion1 !== "NONE" ? Number(region1Rate) || 0 : 0) +
        (selectedRegion2 !== "NONE" ? Number(region2Rate) || 0 : 0) +
        (selectedRegion3 !== "NONE" ? Number(region3Rate) || 0 : 0);

      return (
        <>
          {this.renderRegionRow(0, "Advisor Region", selectedRegion1, region1Rate)}
          {selectedRegion1 !== "NONE" && this.renderRegionRow(1, "Policy Region", selectedRegion2, region2Rate)}
          {selectedRegion2 !== "NONE" && this.renderRegionRow(2, "Region (Optional)", selectedRegion3, region3Rate)}
          {hasAnyRegion && (
            <div style={{ fontSize: 12, color: rateSum === 100 ? "green" : "red", marginTop: 4 }}>
              Rate total: {rateSum}% {rateSum !== 100 && "(must equal 100%)"}
            </div>
          )}
        </>
      );
    }

    setSelectedOption = async (selectedOption: any) => {
      var findOption = representatives.find(
        (option) => option == selectedOption
      );
      this.setState({
        selectedRep: findOption,
      });
      this.data.dsPolicy.Representative = findOption;
    };

    existing_account_holder({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Line>
            <Display field={field("PolicyHolder_Id")} />
            <Display field={field("PolicyName")} />
          </Line>
        </Card>
      );
    }

    main_tab({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
          <Column>
            {draw(this.enrollment_type)}
            {draw(this.new_account_holder)}
            {draw(this.existing_account_holder)}
            {draw(this.detail_panel)}
          </Column>
        </Panel>
      );
    }

    details({ field, draw, action }: RenderEvent) {
      return (
        <Card label="Primary Advisor">
          <Line>
            <Display field={field("PrimaryAdvisor_Id")} />
            <Display field={field("DistroAccount")} />
          </Line>
          <NationalDistributionPartnerBadge
            show={!!this.data.dsPolicy.IsNationalDistributionPartner}
          />
          <div>
            Click on the magnifying glass, then enter the advisor name and click
            "Search"
          </div>
        </Card>
      );
    }

    enrollment_type({ field, draw, action }: RenderEvent) {
      return (
        <RadioButtons
          field={field("@dsPolicy.Mode")}
          hideLabel
          direction="horizontal"
        />
      );
    }

    benefit_year({ field, draw, action }: RenderEvent) {
      return (
        <Card label="Benefit year">
          <Line>
            <Display
              field={field("@dsBenefitYear.StartDate")}
              toolTip={
                <CustomToolTip
                  header="Start Date"
                  bodyContent="To backdate correctly, you must backdate both this benefit year and the Product Effective Date under the “Products” tab. A policy can only be backdated up to a maximum of 2 years prior to the Benefit End Date."
                />
              }
            />
            <Display field={field("@dsBenefitYear.EndDate")} />
            <Display
              field={field("@dsBenefitYear.RunoffMonths")}
              toolTip={
                <CustomToolTip
                  header="RunOff Months"
                  bodyContent="Instead of days, employees have run-off month(s) to get their previous year receipts submitted."
                />
              }
            />
          </Line>
          <div>
            If backdating an enrollment, follow the (i) instructions carefully
          </div>
        </Card>
      );
    }

    detail_panel({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
          <Column>{draw(this.details)}</Column>
          <Column>{draw(this.benefit_year)}</Column>
        </Panel>
      );
    }

    async submit({ screen }: ActionEvent) {
      if (
        this.data.dsPolicy.Representative == undefined ||
        this.data.dsPolicy.Representative == "-- Select --" ||
        this.data.dsPolicy.Representative == "NONE"
      ) {
        this.data.dsPolicy.Representative = null;
      }

      this.data.dsPolicy.Region1 = this.state.selectedRegion1 === "NONE" ? null : this.state.selectedRegion1;
      this.data.dsPolicy.Region1Rate = this.state.selectedRegion1 === "NONE" ? 0 : this.state.region1Rate;
      this.data.dsPolicy.Region2 = this.state.selectedRegion2 === "NONE" ? null : this.state.selectedRegion2;
      this.data.dsPolicy.Region2Rate = this.state.selectedRegion2 === "NONE" ? 0 : this.state.region2Rate;
      this.data.dsPolicy.Region3 = this.state.selectedRegion3 === "NONE" ? null : this.state.selectedRegion3;
      this.data.dsPolicy.Region3Rate = this.state.selectedRegion3 === "NONE" ? 0 : this.state.region3Rate;

      if (
        this.props.policyNumbers &&
        this.props.policyNumbers.includes(this.state.policyNumber)
      ) {
        this.data.dsPolicy.PolicyNo = this.props.new_policy_id;
        toastr.error("Policy number already exists");
      } else {
        this.data.dsPolicy.PolicyNo = this.state.policyNumber;

        try {
          const response = await axios.get(
            "/api/enrollment/checkpolicyholdernameduplicate",
            {
              params: { name: this.data.dsPolicy.PolicyHolderName },
            }
          );

          if (response.data === true) {
            toastr.error("Policy name already exists");
          } else {
            KTMApi.action(screen, "submit", {
              "@dsPolicy.Mode": this.data.dsPolicy.Mode,
              "@dsPolicy.PolicyHolder_Id": this.data.dsPolicy.PolicyHolder_Id,
              "@dsPolicy.PolicyNo": this.data.dsPolicy.PolicyNo,
              "@dsPolicy.PolicyName": this.data.dsPolicy.PolicyName,
              "@dsPolicy.PolicyHolderName": this.data.dsPolicy.PolicyHolderName,
              "@dsPolicy.PrimaryAdvisor_Id":
                this.data.dsPolicy.PrimaryAdvisor_Id,
              "@dsPolicy.Representative": this.data.dsPolicy.Representative,
              "@dsPolicy.Region1": this.data.dsPolicy.Region1,
              "@dsPolicy.Region1Rate": this.data.dsPolicy.Region1Rate,
              "@dsPolicy.Region2": this.data.dsPolicy.Region2,
              "@dsPolicy.Region2Rate": this.data.dsPolicy.Region2Rate,
              "@dsPolicy.Region3": this.data.dsPolicy.Region3,
              "@dsPolicy.Region3Rate": this.data.dsPolicy.Region3Rate,
              "@dsBenefitYear.StartDate": this.data.dsBenefitYear.StartDate,
              "@dsBenefitYear.EndDate": this.data.dsBenefitYear.EndDate,
              "@dsBenefitYear.RunoffMonths":
                this.data.dsBenefitYear.RunoffMonths,
            });
            screen.close({ continue: true });
          }
        } catch (error) {
          toastr.error("Failed to add new policy", "Error");
          screen.close({ continue: true });
        } 
      }
    }

    async mode_onchange({ screen, eventValue }: ActionEvent) {
      if (eventValue == "ADD") {
        screen.setValue("@dsPolicy.PolicyHolderName", null);
        screen.hide(this.new_account_holder);
        screen.unhide(this.existing_account_holder);
      } else {
        screen.setValue("@dsPolicy.PolicyHolder_Id", null);
        screen.setValue("@dsPolicy.PolicyName", null);
        screen.hide(this.existing_account_holder);
        screen.unhide(this.new_account_holder);
      }
    }

    async advisor_onchange({ screen, eventValue }: ActionEvent) {
      await KTMApi.onValueChanged(screen, "@dsPolicy.PrimaryAdvisor_Id", {
        "@event-value": eventValue,
      });
    }
  }
);
